module.exports = __webpack_public_path__ + "img/xx(2).45837238.png";